import React from 'react';  
import {Link} from 'react-router-dom';
import SecondPage from '../pages/SecondPage';
import Subscription from '../pages/Subscription';
import Blogdata from '../pages/Blogdata';

class Fixedratebond extends React.Component{
 
 constructor(props) {

    super(props);
    this.state = {
     id: ''
     };
  }
  

 render(){
 const id = this.props.match.params.id;
 
 return(
<div>
   <section className="container">
	<div className="row">
		<div className="col-sm-12">
			<ul className="breadcrumbs">
				<li><Link to={'/'}>Home</Link> <i className="fas fa-chevron-right"></i></li>
				<li><Link to={'/'}>Savings Accounts</Link> <i className="fas fa-chevron-right"></i></li>
				<li>1 Year Fixed Rate Bonds</li>
			</ul>
		</div>
	</div>
</section>
<section className="section-pading">
	<div className="container">
		<div className="row">
			<div className="col-sm-12 col-md-5">
				<h1 className="banner-hding">1 Year Fixed Rate Bond</h1>
				<p className="banner-prgh">Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
				
			</div>
			<div className="col-sm-12 col-md-4">
				<img src={process.env.PUBLIC_URL + '/assets/sites/default/files/banner-fixedratebond.png'} alt="banner-fixedratebond" className="img-fluid mt-5"/>
			</div>
			<div className="col-sm-12 col-md-3 pl-md-0">
				<img src={process.env.PUBLIC_URL + '/assets/sites/default/files/advertisement-img.jpg'} alt="advertisement-img" className="img-fluid banner-advertisimg"/>
			
			</div>
		</div>
	</div>	
</section>				

<SecondPage id={id} />

<Subscription/>

<section className="light-bg">
	<div className="container">
		<div className="row justify-content-center">
			<div className="col-sm-12">
				<div className="block-page-title-block">
					<h1 className="page-title">About Intellisavings</h1>
					<p className="py-4">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
				</div>
			</div>
			<div className="col-xl-10">
				<div className="row">
					<div className="col-md-4 mb-4">
						<div className="about-step-area">
							<div className="about-leftshade"></div>
							<div className="about-rightshade"></div>
							<h3 className="about-circle-step">1</h3>
							<p className="about-circle-botxt">Select saving provider</p>
						</div>	
					</div>
					<div className="col-md-4 mb-4">
						<div className="about-step-area">
							<div className="about-leftshade"></div>
							<div className="about-rightshade"></div>
							<h3 className="about-circle-step">2</h3>
							<p className="about-circle-botxt">Link your account and product</p>
						</div>	
					</div>
					<div className="col-md-4 mb-4">
						<div className="about-step-area">
							<div className="about-leftshade"></div>
							<div className="about-rightshade"></div>
							<h3 className="about-circle-step">3</h3>
							<p className="about-circle-botxt">See you save</p>
						</div>	
					</div>		
				</div>
			</div>
			<div className="col-sm-12 col-md-8 col-lg-7">
				<div className="row justify-content-center">
					<div className="col-sm-5 col-md-7">
						<p className="download-apptext">Download our app now</p>	
					</div>
					<div className="col-sm-5">
						<div className="flex justify-content-center align-items-center">
							<Link to={'/'}><img src="../assets/sites/default/files/app-store.png" alt="app-store" className="mr-2"/></Link>
							<Link to={'/'}><img src="../assets/sites/default/files/g-play-store.png" alt="g-play-store" className="mr-2"/></Link>
						</div>	
					</div>
				</div>
			</div>	
		</div>
	</div>
</section>

<section className="section-pading">
	<div className="container">
		<div className="row">
			<div className="col-sm-12 col-md-12">
				<div className="block-page-title-block">
					<h1 className="page-title">Type of Accounts</h1>
				</div>
			</div>
			<div className="col-sm-12 col-md-6">
				<img src="../assets/sites/default/files/type-of-account.png" alt="type-of-account" className="img-fluid mb-3 mb-md-0 pt-2"/>
			</div>
			<div className="col-sm-12 col-md-6">
				<div className="block-page-title-block text-left mb-3 mb-md-4">
					<p className="mb-0">Savings account has been designed specifically to take care of your banking and savings requirements. Our innovative financial solutions, backed by expert advice will provide you with a truly rewarding banking.</p>
				</div>
				<div className="d-none d-lg-block">
					<div className="row">
						<div className="col-sm-6">
							<ul className="type-aclist">
								<li><img src="../assets/sites/default/files/file-icon.png" alt="file-icon1"/> Easy & Limited Access</li>
								<li><img src="../assets/sites/default/files/file-icon.png" alt="file-icon2"/> Fixed Terms Bond</li>
								<li><img src="../assets/sites/default/files/file-icon.png" alt="file-icon3"/> Tax-free Saving (ISA)</li>
							</ul>
						</div>
						<div className="col-sm-6">
							<ul className="type-aclist">
								<li><img src="../assets/sites/default/files/file-icon.png" alt="file-icon4"/> Regular Saver</li>
								<li><img src="../assets/sites/default/files/file-icon.png" alt="file-icon5"/> Notice Account</li>
								<li><img src="../assets/sites/default/files/file-icon.png" alt="file-icon6"/> Junior & Children</li>
							</ul>
						</div>
					</div>
				</div>	
			</div>	
			<div className="col-sm-12 col-md-12 offest-md-6 d-block d-lg-none">
				<div className="row">
					<div className="col-sm-6">
						<ul className="type-aclist">
							<li><img src="../assets/sites/default/files/file-icon.png" alt="file-icon7"/> Easy & Limited Access</li>
							<li><img src="../assets/sites/default/files/file-icon.png" alt="file-icon8"/> Fixed Terms Bond</li>
							<li><img src="../assets/sites/default/files/file-icon.png" alt="file-icon9"/> Tax-free Saving (ISA)</li>
						</ul>
					</div>
					<div className="col-sm-6">
						<ul className="type-aclist">
							<li><img src="../assets/sites/default/files/file-icon.png" alt="file-icon10"/> Regular Saver</li>
							<li><img src="../assets/sites/default/files/file-icon.png" alt="file-icon11"/> Notice Account</li>
							<li><img src="../assets/sites/default/files/file-icon.png" alt="file-icon12"/> Junior & Children</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>	
</section>
<section className="pos-section">
	<div className="container">
		<div className="row">
			<div className="col-sm-12 col-md-12">
				<div className="block-page-title-block">
					<h1 className="page-title">Purpose of your saving</h1>
				</div>
			</div>
			<div className="col-sm-12 col-md-6">
				<div className="pos-area">
					<div className="d-flex">
						<div className="pos-img">
							<img src="../assets/sites/default/files/deposit-icon.png" alt="deposit-icon" />
						</div>
						<div className="pos-textarea">
							<h5 className="pos-hding">Mortgage Deposit/Repayment</h5>
							<p className="pos-prgh">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text</p>
						</div>
					</div>
				</div>	
			</div>	
			<div className="col-sm-12 col-md-6">
				<div className="pos-area">
					<div className="d-flex">
						<div className="pos-img">
							<img src="../assets/sites/default/files/holiday-icon.png" alt="holiday-icon" />
						</div>
						<div className="pos-textarea">
							<h5 className="pos-hding">Family Holiday</h5>
							<p className="pos-prgh">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text</p>
						</div>
					</div>
				</div>	
			</div>	
			<div className="col-sm-12 col-md-6">
				<div className="pos-area">
					<div className="d-flex">
						<div className="pos-img">
							<img src="../assets/sites/default/files/retirement-icon.png" alt="retirement-icon" />
						</div>
						<div className="pos-textarea">
							<h5 className="pos-hding">Retirement</h5>
							<p className="pos-prgh">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text</p>
						</div>
					</div>
				</div>	
			</div>	
			<div className="col-sm-12 col-md-6">
				<div className="pos-area">
					<div className="d-flex">
						<div className="pos-img">
							<img src="../assets/sites/default/files/tax-free-icon.png" alt="tax-free-icon" />
						</div>
						<div className="pos-textarea">
							<h5 className="pos-hding">Tax-free Savings</h5>
							<p className="pos-prgh">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text</p>
						</div>
					</div>
				</div>	
			</div>	
			<div className="col-sm-12 col-md-6">
				<div className="pos-area">
					<div className="d-flex">
						<div className="pos-img">
							<img src="../assets/sites/default/files/education-icon.png" alt="education-icon" />
						</div>
						<div className="pos-textarea">
							<h5 className="pos-hding">Education</h5>
							<p className="pos-prgh">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text</p>
						</div>
					</div>
				</div>	
			</div>	
			<div className="col-sm-12 col-md-6">
				<div className="pos-area">
					<div className="d-flex">
						<div className="pos-img">
							<img src="../assets/sites/default/files/deposit-icon.png" alt="deposit-icon" />
						</div>
						<div className="pos-textarea">
							<h5 className="pos-hding">Mortgage Deposit/Repayment</h5>
							<p className="pos-prgh">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text</p>
						</div>
					</div>
				</div>	
			</div>	
		</div>
	</div>
</section>

<Blogdata/>	

<section>
	<div className="container">
		<div className="row mb-4 pb-3">
			<div className="col-sm-12 col-md-12">
				<div className="socialarea">
					<div className="row">
						<div className="col-sm-5">
							<p className="download-apptext">Find us over social media</p>
						</div>
						<div className="col-sm-7">
							<div className="flex justify-content-center justify-content-md-end align-items-center">
								<ul className="socialicon">
									<li><Link to={'/'}><i className="fab fa-facebook-f"></i></Link></li>
									<li><Link to={'/'}><i className="fab fa-twitter"></i></Link></li>
									<li><Link to={'/'}><i className="fab fa-linkedin-in"></i></Link></li>
									<li><Link to={'/'}><i className="fab fa-youtube"></i></Link></li>
								</ul>
							</div>
						</div>	
					</div>	
				</div>
			</div>
		</div>
	</div>
</section>

<section className="container">
	<div className="row mt-3 mb-5 pb-4">
		<div className="col-sm-12">
			<div className="newsletter-area">
				<div className="row">
					<div className="col-sm-5">
						<p className="download-apptext">Download our app now</p>
					</div>
					<div className="col-sm-7">
						<div className="d-flex justify-content-end">
							<Link to={'/'}><img src="../assets/sites/default/files/app-store.png" alt="app-store" className="mr-2" /></Link>
							<Link to={'/'}><img src="../assets/sites/default/files/g-play-store.png" alt="g-play-store" className="mr-2" /></Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
	</div>
		)
	}
}

export default Fixedratebond;